export default "__VITE_ASSET__DvfNvM6U__"